import "./BlogPage.scss"
import ArticleCard from "../../components/ArticleCard/ArticleCard"
import FadeIn from "../../components/FadeIn/FadeIn";
import { getDataFromCMS } from "../../service/service";
import Spinner from "../../components/Spinner/Spinner";

import { useEffect, useState } from "react"

const Section = ({ children }) => {
  const [ref, isVisible] = FadeIn(0.2);
  return (
    <section ref={ref} className={`fade-in-section ${isVisible ? "visible" : ""}`}>
      {children}
    </section>
  );
};

const BlogPage = () => {

    const [allBlogs, setAllBlogs] = useState(null)

    useEffect(() => {
      getDataFromCMS("blog").then((data) => {
        setAllBlogs(data)
      }).catch(() => {
        setAllBlogs(false)
      })

    }, [])


    return (
        <main>
          <Section>
            <section className="blog-page">
                <div className="container">
                <h1>Blog</h1>
                {
                  allBlogs === null ?  <Spinner className="blog__spiner" />  : !allBlogs ? <div>Not found!</div> : 

                  <div className="blog-page__wrapper">

                    { allBlogs.map(article => <ArticleCard key={article.id}  article={article}/>) }

                  </div>
                }

                </div>
            </section>

          </Section>
        </main>
    )

}

export default BlogPage